import { questionPropertyMapper } from '@exam-management/common/utils';
import { QConfigQuestionType, type QConfigMetadata } from '@exam-management/graphql';

export function formatSummaryQuestion(metadata: Partial<QConfigMetadata>) {
  const { conditions } = metadata;

  const result: Record<string, number | null> = {
    calculated: null,
    notCalculated: null,
    single: null,
    itemSet: null,
    easy: null,
    medium: null,
    hard: null,
  };

  if (conditions) {
    const { questionTypes, tags } = conditions;

    for (const { type, needTotal } of questionTypes) {
      switch (type) {
        case QConfigQuestionType.Single:
          result.single = needTotal;
          break;
        case QConfigQuestionType.ItemSet:
          result.itemSet = needTotal;
          break;
        default:
          break;
      }
    }

    for (const tagItem of tags) {
      const {
        tag: { name },
        needTotal,
      } = tagItem;

      const key = questionPropertyMapper[name as keyof typeof questionPropertyMapper];
      if (key) {
        result[key] = needTotal;
      }
    }
  }

  return result;
}
